import { render, staticRenderFns } from "./oem.vue?vue&type=template&id=42f047dc&"
import script from "./oem.vue?vue&type=script&lang=js&"
export * from "./oem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports